import React, { useState } from "react";
import "./Concept.scss";
import { Fade } from "react-reveal";
import { conceptInfo } from "../../portfolio";

export default function Concept() {
  const [activeStep, setActiveStep] = useState(null);

  const toggleStep = (stepNumber) => {
    setActiveStep(activeStep === stepNumber ? null : stepNumber);
  };

  if (!conceptInfo.display) return null;

  return (
    <div className="concept-section" id="concept">
      <h1 className="concept-heading">{conceptInfo.title}</h1>
      <Fade bottom duration={1000} distance="20px">
        <div className="concept-text-container">
          <p className="concept-text">{conceptInfo.description}</p>
        </div>
      </Fade>
      <Fade bottom duration={1000} distance="20px">
        <div className="concept-image-container">
          <img
            src={conceptInfo.conceptImage}
            alt="Concept of Operations"
            className="concept-image"
          />
        </div>
      </Fade>
      <Fade bottom duration={1000} distance="20px">
        <div className="concept-steps-container">
          <h2 className="concept-steps-heading">Mission Steps</h2>
          <div className="concept-steps-list">
            {conceptInfo.steps &&
              conceptInfo.steps.map((step) => (
                <div
                  key={step.number}
                  className={`concept-step-item ${
                    activeStep === step.number ? "active" : ""
                  }`}
                  onClick={() => toggleStep(step.number)}
                >
                  <div className="concept-step-header">
                    <div className="step-number">{step.number}</div>
                    <h3 className="step-title">{step.title}</h3>
                  </div>
                  <div className="step-description">
                    <p>{step.description}</p>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </Fade>
    </div>
  );
}